/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { downloadTransactionsStatementPostRequestSchema } from './downloadTransactionsStatementPostRequestSchema.ts';
import { downloadTransactionsStatementPostResponseSchema } from './downloadTransactionsStatementPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postDownloadTransactionsStatement200Schema = z.lazy(() => downloadTransactionsStatementPostResponseSchema);

/**
 * @description 505 response
 */
export const postDownloadTransactionsStatement505Schema = z.any();

export const postDownloadTransactionsStatementMutationRequestSchema = z.lazy(
  () => downloadTransactionsStatementPostRequestSchema
);

export const postDownloadTransactionsStatementMutationResponseSchema = z.lazy(
  () => postDownloadTransactionsStatement200Schema
);
